import { Subject } from "rxjs";
import { AllEvents } from "./all-events";

export const globalStore = new Subject<AllEvents>();
